import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/solid";
import React from "react";

type SortIconProps = {
  isSorting: boolean;
  isSortedAsc: boolean;
}

const SIZE = 16;

const SortIcon = ({ isSorting, isSortedAsc }: SortIconProps) => {
  return (
    <div className="flex flex-col items-center">
      <ChevronUpIcon
        width={SIZE}
        height={SIZE}
        className={`-mb-1 ${
          isSorting ? (!isSortedAsc ? "" : "opacity-0") : ""
        }`}
      />
      <ChevronDownIcon
        width={SIZE}
        height={SIZE}
        className={`-mt-1 ${isSorting ? (isSortedAsc ? "" : "opacity-0") : ""}`}
      />
    </div>
  );
};

export default SortIcon;
